import React from 'react'

import { Skeleton } from '@mui/material'
import { useCustomerLeadsEstimatedUsage } from 'features/customers/hooks/useCustomerLeadsEstimatedUsage'
import { formatEstimatedCompanies } from 'features/customers/utils/leads'

import type { EPlanName } from '@albacross/types'

type CustomerEstimatedCompaniesProps = {
  planName?: EPlanName
}

const CustomerEstimatedCompanies = ({ planName }: CustomerEstimatedCompaniesProps) => {
  const { data, isPending, isError } = useCustomerLeadsEstimatedUsage(planName)

  if (isPending) {
    return <Skeleton variant="text" width={85} />
  }

  if (isError) {
    return 'Error while getting the estimate'
  }

  return formatEstimatedCompanies(data)
}

export default CustomerEstimatedCompanies
